import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import useModalTitulosCedidosHook from '../../hooks/useModalTitulosCedidosHook';

const ModalTitulosCedidos = ({ open, onClose, setCarregarTela }) => {
  const { suspendeCesssao, loadBtnConfirmar, handleClose } = useModalTitulosCedidosHook({
    open,
    onClose,
    setCarregarTela
  });

  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth className="dialog-conta">
      <DialogTitle className="titulo-modal">Atenção</DialogTitle>
      <DialogContent className="dialog-conta__content">
        <Typography variant="body2" className="dialog-conta__subtitle">
          Há títulos que já constam em cessões, será necessário retornar e escolher novos títulos.
        </Typography>
      </DialogContent>
      <DialogActions className="dialog-conta__actions modal-confirmacao-conta">
        <Button
          variant="contained"
          onClick={() => suspendeCesssao()}
          className="dialog-conta__btn-escolher"
          disabled={loadBtnConfirmar}
        >
          {!loadBtnConfirmar && <>Confirmar</>}
          {loadBtnConfirmar && <>Confirmando...</>}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalTitulosCedidos;
